import React from 'react';
import { CellProps } from 'react-table';

import { IInvoice } from 'src/types/invoice';
import DeleteInvoiceAction from './DeleteInvoiceAction';

const InvoiceActionsColumn: React.FunctionComponent<CellProps<IInvoice>> = ({
    cell: {
        row: { original },
    },
}: CellProps<IInvoice>) => {
    return <div>{original.isManualProceed && <DeleteInvoiceAction data={original} />}</div>;
};

export default InvoiceActionsColumn;
